import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";

import { Term, Section } from "@/interfaces";
import { getTerms, deleteTerm, addTerm, updateTerm, getSections } from "@/services";

import store from "@/store";

export interface TermsManagementState {
  terms: Term[];
  sections: Section[];
  errorMessage: string | null;
  loading: boolean;
}

export const initialState: TermsManagementState = {
  terms: [],
  sections: [],
  errorMessage: null,
  loading: false,
};

@Module({ name: "termsmanagement", namespaced: true, store })
export default class TermsManagement extends VuexModule implements TermsManagementState {
  terms: Term[] = [];
  sections: Section[] = [];
  errorMessage: string | null = null;
  loading = false;

  @Action({ rawError: true })
  async search() {
    try {
      this.context.commit("setLoading", true);
      const terms = await getTerms();
      const sections = await getSections();
      this.context.commit("termsSuccess", terms);
      this.context.commit("setSections", sections);
      this.context.commit("setLoading", false);
    } catch (error) {
      this.context.commit("termsFail", error);
      this.context.commit("setLoading", false);
      return Promise.reject(error);
    }
  }

  @Action({ rawError: true })
  async deleteTerm(termId: number) {
    try {
      this.context.commit("setLoading", true);
      await deleteTerm(termId);
      const terms = await getTerms();
      this.context.commit("termsSuccess", terms);
      this.context.commit("setLoading", false);
    } catch (error) {
      this.context.commit("termsFail", error);
      this.context.commit("setLoading", false);
      return Promise.reject(error);
    }
  }

  @Action({ rawError: true })
  async addTerm({ term, onUploadProgress }: { term: Term; onUploadProgress: (progressEvent: ProgressEvent) => void }) {
    try {
      this.context.commit("setLoading", true);
      await addTerm(term, onUploadProgress);
      const terms = await getTerms();
      this.context.commit("termsSuccess", terms);
      this.context.commit("setLoading", false);
    } catch (error) {
      this.context.commit("termsFail", error);
      this.context.commit("setLoading", false);
      return Promise.reject(error);
    }
  }

  @Action({ rawError: true })
  async updateTerm({
    term,
    onUploadProgress,
  }: {
    term: Term;
    onUploadProgress: (progressEvent: ProgressEvent) => void;
  }) {
    try {
      this.context.commit("setLoading", true);
      await updateTerm(term, onUploadProgress);
      const terms = await getTerms();
      this.context.commit("termsSuccess", terms);
      this.context.commit("setLoading", false);
    } catch (error) {
      this.context.commit("termsFail", error);
      this.context.commit("setLoading", false);
      return Promise.reject(error);
    }
  }

  @Mutation
  termsSuccess(payload: Term[]) {
    this.terms = payload;
  }

  @Mutation
  setSections(sections: Section[]) {
    this.sections = sections;
  }

  @Mutation
  termsFail(error: string) {
    this.errorMessage = error;
  }

  @Mutation
  setLoading(status: boolean) {
    this.loading = status;
  }
}
